import api from "@/api/products/products";

const getCapacity = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getCapacity(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const productList = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .products(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getCapacitySettings = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getCapacitySettings(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const updateProduct = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updateProduct(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const uploadProductImages = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .uploadProductImages(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createCapacitySettings = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createCapacitySettings(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const editCapacitySettings = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .editCapacitySettings(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deleteCapacitySettings = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteCapacitySettings(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const productGroupList = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .productGroupList(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const updatePorductGroup = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updatePorductGroup(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

export default {
  getCapacity,
  productList,
  getCapacitySettings,
  createCapacitySettings,
  editCapacitySettings,
  deleteCapacitySettings,
  updateProduct,
  uploadProductImages,
  productGroupList,
  updatePorductGroup,
};
